import type { AxiosInstance } from 'axios'

import { createCitiesModule } from '@/api/modules/city'
import { createCommonService } from '@/api/modules/common'

export function createApiService({
  sentry,
  axios,
  hostname,
}: {
  sentry: any
  axios: AxiosInstance
  hostname: string
}) {
  const commonModule = createCommonService({ axios, sentry, hostname })
  const citiesModule = createCitiesModule({ axios, sentry })

  return {
    common: commonModule,
    cities: citiesModule,
  }
}
